<template lang='pug'>
    v-content
      ProposalViewEmail(v-if="dataapproval && dataapproval.imType == 4 && dataapproval.imDate > '2019-11-19T17:27:05+07:00'" :dialogType="dialogType" :activeStatus="activeStatus" :imItems="dataapproval" :viewer="viewer")
      IMViewEmail(v-else-if="dataapproval" :dialogType="dialogType" :activeStatus="activeStatus" :imItems="dataapproval" :viewer="viewer")
</template>
<script>
import * as i18n from "../data/i18n.json";
import IMViewEmail from "@/components/IMViewEmail.vue";
import ProposalViewEmail from "@/components/ProposalViewEmail.vue";
import axios from "axios";
import { mapState } from "vuex";
import { setTimeout } from "timers";
export default {
  name: "Approval",
  components: {
    IMViewEmail,
    ProposalViewEmail
  },
  data() {
    return {
      i18n: i18n.default,
      dialog: false,
      dialog2: false,
      dataapproval: null,
      // datauserreq: null, :userDetail="datauserreq"
      action: null,
      dialogType: "spv",
      activeStatus: null,
      status_wording: "Approval",
      comment: null,
      viewer: null
    };
  },
  async mounted() {
    const p = this.$route.params;
    const url = `${this.API_URL}/report/lastapproval/${p.im_no}/${p.token}`;
    const res = await axios.get(url);
    //if (res.data.message) return (this.message = res.data.message);
    const status_approval = res.data.result.action;
    this.action = status_approval;
    
    if (status_approval < 0) {
      // this.datauserreq = res.data.datauserreq;
      this.dataapproval = res.data.dataapproval;
      this.activeStatus = res.data.activeStatus;
      this.viewer = res.data.result;
    }
  },
  watch: {
    dialog2 (val) {
      if (!val) return
      const config = {
        method: "put",
        url: `${this.$store.state.API_URL}/api/update/requests`,
        headers: {"Authorization": `Bearer ${this.$route.params.token}`},
        data: {
          _id: this.$route.params.im_no,
          status: parseInt(this.action),
          comment: this.comment}
      };
      axios(config).then(res => {
        if (res.status == 200) {
          setTimeout(() => {
              this.dialog2 = false;
              this.dialog = false;
              this.message = "Process "+this.status_wording+" for this request is success";
            },
          1000);
        }
      });
      
    }
  },
  computed: {
    ...mapState(["API_URL"])
  }
};
</script>
